<template>
  <div class="quantity-picker">
    <button class="quantity-picker__btn" @click="decrement" :disabled="quantity === 1"></button>
    <input class="quantity-picker__value" type="number" @input="updateQuantity" :value="quantity" :min="min" :max="max" />
    <button class="quantity-picker__btn" @click="increment">+</button>
  </div>
</template>

<script>
export default {
  name: "QuantityPicker",
  props: {
    value: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: Infinity
    }
  },
  data() {
    return {
      quantity: this.value
    };
  },
  watch: {
    value(newValue) {
      this.quantity = newValue;
    }
  },
  methods: {
    increment() {
      if (this.quantity < this.max) {
        this.quantity++;
        this.$emit("input", this.quantity);
      }
    },
    decrement() {
      if (this.quantity > this.min) {
        this.quantity--;
        this.$emit("input", this.quantity);
      }
    },
    updateQuantity(event) {
      this.quantity = parseInt(event.target.value);
      if (this.quantity < this.min) {
        this.quantity = this.min;
      } else if (this.quantity > this.max) {
        this.quantity = this.max;
      }
      this.$emit("input", this.quantity);
    }
  }
};
</script>
